import MyFlow from "flow/MyFlow";
import config from "flow/config";
import * as systemInfoManager from "./systemInformationManager";
import SystemInfoViewModel from "./SystemInformationViewModel";

export const systemInformationViewModel = new SystemInfoViewModel();

export function setup(): void {
    systemInfoManager.setup();
}

export function showSystemInformationBanner(guid: string, title: string, text: string): void {
    if (systemInfoManager.hasAlreadyBeenClosed(guid) || systemInfoManager.alreadyShownAsDialog(guid)) {
        return;
    }

    systemInformationViewModel.showBanner(guid, title, text);
}

export function showSystemInformationDialog(myFlow: MyFlow, guid: string, title: string, text: string): void {
    if (systemInfoManager.hasAlreadyBeenClosed(guid)) {
        return;
    }

    myFlow.showCustomDialog(config.componentIds.systemInformationDialog, {
        guid: guid,
        title: title,
        text: text
    });

    systemInfoManager.registerDialogAsShown(guid);
}
